<template>
  <div v-if="response.total > response.per_page" class="flex justify-between border-t border-gray-200 bg-white px-0 py-3 sm:px-0">
    <div class="flex flex-1 justify-between sm:hidden">
      <a href="#" class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Previous</a>
      <a href="#" class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Next</a>
    </div>
    <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          Showing
          {{ ' ' }}
          <span class="font-medium">{{ response.from }}</span>
          {{ ' ' }}
          to
          {{ ' ' }}
          <span class="font-medium">{{ response.to }}</span>
          {{ ' ' }}
          of
          {{ ' ' }}
          <span class="font-medium">{{ response.total }}</span>
          {{ ' ' }}
          results
        </p>
      </div>
      <div>
        <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
          <a @click="previous" class="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
            <span class="sr-only">Previous</span>
            <ChevronLeftIcon class="h-5 w-5" aria-hidden="true" />
          </a>

          <template v-for="number in response.last_page">
            <a v-if="response.current_page === number" aria-current="page" class="relative z-10 inline-flex items-center bg-gray-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">{{ number }}</a>
            <a v-show="number <= (response.current_page + 3) && number >= (response.current_page - 3) && number <= (response.last_page - 1)" @click="navigateTo(number)" v-else class="relative hidden items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 md:inline-flex">{{ number }}</a>
          </template>

          <template v-if="response.last_page !== response.current_page">
          <span v-if="response.current_page < (response.last_page - 3)" class="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0">...</span>

          <a @click="navigateTo(response.last_page)" class="relative hidden items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 md:inline-flex">{{ response.last_page }}</a>

          <a @click="next" class="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
            <span class="sr-only">Next</span>
            <ChevronRightIcon class="h-5 w-5" aria-hidden="true" />
          </a>
          </template>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/20/solid'
export default {
  name: "PaginationComponent",
  props: ['response'],
  data: function () {
    return {
      page: null
    }
  },
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  methods:{
    previous() {
      const number = this.response.current_page - 1;
      if (this.response.current_page === 1) {return null;}
      this.changePage(number);

    },
    navigateTo(number) {
      this.changePage(number);
    },
    next() {
      const number = this.response.current_page + 1;
      if (this.response.current_page === this.response.last_page) {return null;}
      this.changePage(number);
    },
    changePage(value) {
      this.$emit('setPage', value)
    }
  }
}
</script>